"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponDetail',
  props: {
    memberData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      searchForm: {
        couponType: ''
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    fetchCouponDetail: function () {
      var _fetchCouponDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userId, params, response, data, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              userId = this.memberData.userId || this.memberData.id;
              if (userId) {
                _context.next = 2;
                break;
              }
              this.$message.warning('缺少用户ID，无法获取发券明细');
              this.loading = false;
              return _context.abrupt("return");
            case 2:
              params = {
                userId: userId,
                page: this.currentPage,
                size: this.pageSize
              };
              if (this.searchForm.couponType !== '') {
                params.couponType = this.searchForm.couponType;
              }
              _context.next = 3;
              return (0, _memberManagement.vipCouponInfo)(params);
            case 3:
              response = _context.sent;
              if (response.code === 200 || response.code === 0) {
                data = response.data;
                this.tableData = data.list || [];
                this.total = data.total || 0;
              } else {
                this.$message.error(response.message || '获取发券明细失败');
              }
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              console.error('获取发券明细失败:', _t);
              this.$message.error('获取发券明细失败');
            case 5:
              _context.prev = 5;
              this.loading = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function fetchCouponDetail() {
        return _fetchCouponDetail.apply(this, arguments);
      }
      return fetchCouponDetail;
    }(),
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchCouponDetail();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchCouponDetail();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchCouponDetail();
    },
    getCouponTypeText: function getCouponTypeText(type) {
      var typeMap = {
        1: '代金券',
        2: '折扣券',
        3: '商品券',
        4: '赠品券',
        5: '配送券'
      };
      return typeMap[type] || '未知类型';
    },
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    }
  },
  mounted: function mounted() {
    this.fetchCouponDetail();
  }
};